import { React, useState, useEffect } from 'react'
import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimation } from "framer-motion";
import { useParams, } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faEnvelope, faPersonChalkboard, faPhone, faGlobe, faBuilding, faList, faScaleBalanced, faCalendarPlus, faCalendarDays, faChampagneGlasses, faUsers } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'

import { lP, oP, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, validateContactFields, validateAddressFields, validateRegistrationExtra } from '../../../main.js'

import '../../../main.css'
import './EventRegister.css'
import './MEventRegister.css'

import img_not_found from '../../../assets/pictures/imgnotfound.webp'

import Cookies from 'universal-cookie'
const cookies = new Cookies()


export default function EventRegister() {

    const { eventid } = useParams();
    var [eventFound, setEventFound] = useState(1)

    var [registerPage, setRegisterPage] = useState(1)
    var [formError, setFormError] = useState(false)
    var [resError, setResError] = useState("")


    var [formData, setFormData] = useState({
        formVorname: "",
        formNachname: "",
        formMail: "",
        formTel: "",
        formMobil: "",
        formAddressStreet: "",
        formAddressHnr: "",
        formAddressPlace: "",
        formAddressPLZ: "",
        formAddressAddon: "",
        formChannelSelect: 1,
        formBirthdate: "",
        formQualifications: "",
        formChbAGB: 0,
        formChbFotos: 0,
        formChbNewsletter: 0

    })

    var [eventData, setEventData] = useState({

        eventId: "",
        eventOrgId: "",
        eventName: "",
        eventLongName: "Event wird geladen...",
        eventLogo: img_not_found,
        eventHeroImg: img_not_found,
        eventURL: "#",
        eventImprintURL: "#",
        eventOrganizator: "unbekannt",
        eventContactURL: "#",
        eventContactMail: "",
        eventContactTel: "",
        eventSlogan: "Mach mit!",
        eventApplicationActive: false,
        eventDates: {
            dateStart: "",
            dateEnd: "",
            applicationStart: "",
            applicationEnd: ""
        },
        eventStyle: {
            colorPrimary: '#662773',
            colorPrimaryGradient: '#986da0',
            colorSecondary: '#94b654',
            colorTileBg: '#f6deff',
            colorStdText: '#000000',
            colorBtnText: '#ffffff',
            colorStdTextOnTile: '#000000'
        },
        eventInfo: {
            box1Header: "Was ist das",
            box1Text: "Eventbeschreibung wird geladen...",
            box1HeroImg: null,
            box2Header: "Deine Aufgaben",
            box2Text1: "Aufgabenbeschreibung wird geladen...",
            box2Text2: "",
            box2CtaText: "Registrieren",
            box3Header: "Eckdaten",
            box3Contents: "",
            box3LookingFor: "",
            box3Text: "Weitere Fragen an den Veranstalter?",
            box3CtaText: "Kontakt"
        }
    })



    useEffect(() => {

        //NOTE removes all cookie data like logout to prevent users from register again with wrong account and instead allow setting up an account for multiple people
        cookies.remove('authtoken')
        cookies.remove('firstname')
        cookies.remove('userid')


        // setFormVorname(new URLSearchParams(window.location.search).get("formVorname"));
        // setFormNachname(new URLSearchParams(window.location.search).get("formNachname"));

        setFormData({ ...formData, formVorname: new URLSearchParams(window.location.search).get("formVorname"), formNachname: new URLSearchParams(window.location.search).get("formNachname") });

        //TODO API Get Event Metadata
        if (eventid == "0" || eventid == null) { } else {
            getEventData()
        }

        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // setFormUsername(document.querySelector('.in_username').value)
                // setFormPassword(document.querySelector('.in_password').value)
                // doLogin()
                // event.preventDefault()
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }


    }, [])
    function getEventData() {

        try {

            fetch(URL_MAINAPI + "/event/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setEventFound(1)
                    applyEventData(res.data);
                } else {
                    setEventFound(0)
                }
            }))
        } catch (err) {
            setEventFound(0)
        }
    }

    function applyEventData(metadata) {
        setEventData({
            eventId: metadata._id,
            eventOrgId: (metadata.organization && metadata.organization._id) ? String(metadata.organization._id) : (metadata.orgid ? String(metadata.orgid) : ""),
            eventName: metadata.name,
            eventLongName: metadata.longname,
            eventLogo: metadata.logo_img,
            eventHeroImg: metadata.hero_img,
            eventURL: metadata.url,
            eventOrganizator: metadata.organization.name,
            eventContactURL: metadata.organization.contact.url,
            eventImprintURL: metadata.organization.contact.imprint_url,
            eventContactMail: metadata.organization.contact.email,
            eventContactTel: metadata.organization.contact.tel,
            eventSlogan: metadata.slogan,
            eventApplicationActive: metadata.applicationActive,
            eventDates: {
                dateStart: metadata.dates.dateStart,
                dateEnd: metadata.dates.dateEnd,
                applicationStart: metadata.dates.applicationStart,
                applicationEnd: metadata.dates.applicationEnd
            },
            eventCustomStyle: metadata.customstyle,
            eventStyle: {
                colorPrimary: metadata.style.colorPrimary,
                colorPrimaryGradient: metadata.style.colorPrimaryGradient,
                colorSecondary: metadata.style.colorSecondary,
                colorTileBg: metadata.style.colorTileBg,
                colorStdText: metadata.style.colorStdText,
                colorBtnText: metadata.style.colorBtnText,
                colorStdTextOnTile: metadata.style.colorStdTextOnTile
            },
            eventInfo: {
                box1Header: metadata.info.box1Header,
                box1Text: metadata.info.box1Text,
                box1HeroImg: metadata.info.box1HeroImg,
                box2Header: metadata.info.box2Header,
                box2Text1: metadata.info.box2Text1,
                box2Text2: metadata.info.box2Text2,
                box2CtaText: metadata.info.box2CtaText,
                box3Header: metadata.info.box3Header,
                box3Contents: metadata.info.box3Contents,
                box3LookingFor: metadata.info.box3LookingFor,
                box3Text: metadata.info.box3Text,
                box3CtaText: metadata.info.box3CtaText
            }
        });

        if (metadata.customstyle) {
            document.documentElement.style.setProperty('--event_color_primary', metadata.style.colorPrimary);
            document.documentElement.style.setProperty('--event_color_primarygradient', metadata.style.colorPrimaryGradient);
            document.documentElement.style.setProperty('--event_color_secondary', metadata.style.colorSecondary);
            document.documentElement.style.setProperty('--event_color_tilebg', metadata.style.colorTileBg);
            document.documentElement.style.setProperty('--event_color_stdtext', metadata.style.colorStdText);
            document.documentElement.style.setProperty('--event_color_stdtextontile', metadata.style.colorStdTextOnTile);
            document.documentElement.style.setProperty('--event_color_btntext', metadata.style.colorBtnText);
        }

    }
    function checkEmail(forward) {
        var reqbody = {
            "firstname": formData.formVorname,
            "lastname": formData.formNachname,
            "email": formData.formMail
        }
        console.log(reqbody);

        try {
            fetch(URL_MAINAPI + "/auth/checkemail", {
                method: "POST",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                console.log(res.data)
                if (res.status == 406) {
                    if (forward == true) { lP("/login?eventid=" + eventid + '&formMail=' + formData.formMail + '&formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname); }
                    return true;
                } else {
                    return false;
                }
            })
            )

        } catch (err) {
            return false;
        }
    }

    function postUserdata() {

        console.log(formData.formBirthdate);

        var bdate = new Date(formData.formBirthdate)
        var bdateiso = bdate.toISOString()
        console.log(bdate.toISOString())

        document.querySelector("#responseInfo_loading").style.display = "block"
        document.querySelector("#responseInfo_wronginput").style.display = "none"

        var reqbody = {
            "firstname": formData.formVorname,
            "lastname": formData.formNachname,
            "contact": {
                "email": formData.formMail,
                "tel": formData.formTel,
                "mobile": formData.formMobil,
            },
            "address": {
                "nr": formData.formAddressHnr,
                "street": formData.formAddressStreet,
                "addon": formData.formAddressAddon,
                "zipcode": formData.formAddressPLZ,
                "city": formData.formAddressPlace
            },
            "birthday": bdateiso,
            "agreements": {
                "newsletter_agreed": formData.formChbNewsletter ? 1 : 0,
                "photos_agreed": formData.formChbFotos ? 1 : 0,
                "agb_agreed": formData.formChbAGB ? 1 : 0,
            },
            "additionalInfo": {
                "qualifications": formData.formQualifications,
                "preferred_channel": formData.formChannelSelect
            },
            "forEvent": 1,
            "eventid": eventid
        }
        console.log(reqbody);
        console.log(formData.formChannelSelect);

        try {

            fetch(URL_MAINAPI + "/auth/register", {
                method: "POST",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    // console.log(res.data.userid)
                    // cookies.set('userid', res.data.userid, { path: '/' })
                    setRegisterPage(4);
                    setResError("");
                } else {
                    console.log(res.data)
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_wronginput").style.display = "block"
                    setResError(res.data.error);
                }
            })
            )
        } catch (err) {
            console.log(err)
            document.querySelector("#responseInfo_loading").style.display = "none"
            document.querySelector("#responseInfo_servererror").style.display = "block"
            setResError(err);
        }
    }

    function nextRegisterPage(currentpage) {
        let valresult;
        switch (currentpage) {
            case 1:
                //TODO wieder aktivieren!! wenn Login fertig    
                checkEmail(true);
                //TODO
                valresult = validateContactFields({ email: formData.formMail, tel: formData.formTel, mobile: formData.formMobil });
                if (valresult.error == null) { setFormError(false); setRegisterPage(2); } else setFormError(true);
                break;
            case 2:
                valresult = validateAddressFields({ nr: formData.formAddressHnr, street: formData.formAddressStreet, addon: formData.formAddressAddon, zipcode: formData.formAddressPLZ, city: formData.formAddressPlace });
                if (valresult.error == null) { setFormError(false); setRegisterPage(3); } else setFormError(true);
                break;
            case 3:
                valresult = validateRegistrationExtra({ newsletter_agreed: formData.formChbNewsletter ? 1 : 0, photos_agreed: formData.formChbFotos ? 1 : 0, agb_agreed: formData.formChbAGB ? 1 : 0, qualifications: formData.formQualifications, preferred_channel: formData.formChannelSelect, birthday: formData.formBirthdate });
                if (valresult.error == null) { setFormError(false); postUserdata() } else setFormError(true);
                break;
            default: setRegisterPage(1);


        }
    }


    if (eventid == "0" || eventid == null || eventFound == 0) { //TODO no event found
        return (
            <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon'>
                <MainHeader selectedsite={""} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Eventanmeldung</title>
                    <meta name="robots" content="noindex" />

                </Helmet>
                <main className='page-body'>
                    <div className='container'>
                        <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card error-card'>
                                <h3>Das gesuchte Event wurde nicht gefunden!</h3>
                                <p>Bitte kehre zur vorigen Seite zurück. Oder versuche den Veranstalter zu kontaktieren.</p><br />
                                <CTAButton variant="primary" hideArrow={true} title={"Startseite"} onclick={() => lP('/')}></CTAButton>
                            </div>
                        </motion.div>
                    </div>
                </main>

                < MainFooter useEventStyle={true} />
            </div >
        );
    }
    if (formData.formVorname == "" || formData.formNachname == "") {
        return (
            <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon'>
                <MainHeader selectedsite={""} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Eventanmeldung</title>
                    <meta name="robots" content="noindex" />

                </Helmet>

                <div className='eventbar'>
                    <div className='eventbar-inner'>
                        <motion.img variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} alt='Logo des Veranstalters bzw. der Organisation' className='eventbar-logo' src={eventData.eventLogo} onClick={() => oP(eventData.eventURL)}></motion.img>
                        <motion.h2 variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} className='eventbar-name'>{eventData.eventName == "" ? <Skeleton height={22} width="60%" /> : eventData.eventLongName}</motion.h2>
                    </div>
                </div>

                <main className='page-body'>
                    <div className='container'>
                        <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card error-card'>
                                <h3>Deine Angaben sind unvollständig!</h3>
                                <p>Bitte kehre zur vorigen Seite zurück und vervollständige deine Angaben.</p><br />
                                <CTAButton variant="primary" hideArrow={true} title={"Zurück"} onclick={() => window.history.back(1)}></CTAButton>
                            </div>
                        </motion.div>
                    </div>
                </main>

                < MainFooter useEventStyle={true} />
            </div >
        );
    }

    return (
        <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Eventanmeldung für {eventData.eventName}</title>
                <meta property="og:title" content={"Anmeldung für Helferzeit-Event: " + eventData.eventName} />
                <meta property="og:description" content={"Registriere dich hier für die Veranstaltung auf Helferzeit: " + eventData.eventLongName + "."} />
                <meta name="robots" content="noindex" />

            </Helmet>

            <div className='eventbar'>
                <div className='eventbar-inner'>
                    <motion.img variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} alt='Logo des Veranstalters bzw. der Organisation' className='eventbar-logo' src={eventData.eventLogo} onClick={() => oP(eventData.eventURL)}></motion.img>
                    <motion.h2 variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} className='eventbar-name' onClick={() => lP('/event/' + eventid)} style={{ cursor: "pointer" }}>{eventData.eventName == "" ? <Skeleton height={22} width="60%" /> : eventData.eventLongName}</motion.h2>
                </div>
            </div>

            <main className='page-body'>
                <section className='container section' style={{ paddingTop: '40px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card register-card'>

                            {(registerPage == 1) ?
                                //PAGE 1
                                < div className='register_squircle_cont'>
                                    <div className='register_squircle_first_cont'>
                                        <h3>Hey {formData.formVorname}, wie können wir dich erreichen?</h3>

                                        <form>
                                            <div className="field tip-parent">
                                                <b>Deine E-Mailadresse</b>
                                                <input type="email" className="in_mail" name="mail" placeholder="E-Mail" autoFocus value={formData.formMail} autoComplete='on' onInput={(e) => setFormData({ ...formData, formMail: e.target.value })}></input>
                                            </div>
                                            <div className="field tip-parent">
                                                <b>Deine Telefonnummer</b>
                                                <input type="tel" className="in_tel" name="tel" placeholder="Telefonnummer (+49 1..)" value={formData.formTel} autoComplete='on' onInput={(e) => setFormData({ ...formData, formTel: e.target.value })}></input>
                                            </div>
                                            <div className="field tip-parent">
                                                <b>Dein Handynummer</b>
                                                <input type="tel" className="in_mobil" name="mobil" placeholder="Mobilnummer (optional)" value={formData.formMobil} autoComplete='on' onInput={(e) => setFormData({ ...formData, formMobil: e.target.value })}></input>
                                            </div>
                                            <br />
                                            {(formError) ? <b className='form_error_message'>Bitte fülle alle Pflichtfelder korrekt aus.</b> : <div></div>}

                                            <br /><br />
                                            <CTAButton variant="primary" id="next_btn" hideArrow={false} title={"Weiter"} onclick={() => nextRegisterPage(1)}></CTAButton>
                                            <br /><br /><br />
                                            <a className="action_third_a" href={'/event/' + eventid}>Abbrechen</a>
                                        </form>
                                    </div>
                                    <div className='register_squircle_scnd_cont'>
                                        <FontAwesomeIcon className='register_squircle_icon' icon={faAddressCard} />
                                        <p className='register_squircle_explanation'>
                                            Wir benötigen deine E-Mailadresse, damit du dich später wieder anmelden
                                            kannst und wir dir alle wichtigen Infos zukommen lassen können.<br />
                                            Für Fragen und kurzfristige Änderungen, kontaktiert dich der Veranstalter ggf. per Handy.
                                        </p>
                                    </div>
                                </div> : (registerPage == 2) ?
                                    // PAGE 2
                                    <div className='register_squircle_cont'>
                                        <div className='register_squircle_first_cont'>
                                            <h3>Wohin können wir dir Post schicken, {formData.formVorname}?</h3>

                                            <form>
                                                <div className='inputdiv_line'>
                                                    <div className="field tip-parent">
                                                        <b>Straße</b>
                                                        <input type="text" className="in_street" name="street" placeholder="Straße" autoFocus value={formData.formAddressStreet} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressStreet: e.target.value })}></input>
                                                    </div>
                                                    <div className="field field_short tip-parent">
                                                        <b>Haus-Nr.</b>
                                                        <input type="text" className="in_hnr" name="hnr" placeholder="Nr." value={formData.formAddressHnr} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressHnr: e.target.value })}></input>
                                                    </div>
                                                </div>
                                                <div className='inputdiv_line'>
                                                    <div className="field field_short tip-parent">
                                                        <b>Postleitzahl</b>
                                                        <input type="text" className="in_plz" name="plz" placeholder="PLZ" value={formData.formAddressPLZ} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressPLZ: e.target.value })}></input>
                                                    </div>
                                                    <div className="field tip-parent">
                                                        <b>Wohnort</b>
                                                        <input type="text" className="in_place" name="place" placeholder="Ort" value={formData.formAddressPlace} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressPlace: e.target.value })}></input>
                                                    </div>
                                                </div>
                                                <div className="field tip-parent">
                                                    <b>Adresszusatz</b>
                                                    <input type="text" className="in_addraddon" name="addraddon" placeholder="Adresszusatz (optional)" value={formData.formAddressAddon} autoComplete='on' onInput={(e) => setFormData({ ...formData, formAddressAddon: e.target.value })}></input>
                                                </div>
                                                <br />
                                                {(formError) ? <b className='form_error_message'>Bitte fülle alle Pflichtfelder korrekt aus.</b> : <div></div>}

                                                <br /><br />
                                                <CTAButton variant="primary" id="back_btn" hideArrow={true} title={"Zurück"} onclick={() => setRegisterPage(1)}></CTAButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                                <CTAButton variant="primary" id="next_btn" hideArrow={false} title={"Weiter"} onclick={() => nextRegisterPage(2)}></CTAButton>
                                            </form>
                                        </div>
                                        <div className='register_squircle_scnd_cont'>
                                            <FontAwesomeIcon className='register_squircle_icon' icon={faEnvelope} />
                                            <p className='register_squircle_explanation'>
                                                Wir senden dir alle wichtigen Infos per E-Mail. Auf Wunsch senden dir manche Veranstalter zusätzlich Infos per Post.

                                            </p>
                                            <div className="field field_dyn tip-parent">
                                                <select className="in_channel" name="channel" value={formData.formChannelSelect} placeholder="Informationskanal" required onChange={(e) => setFormData({ ...formData, formChannelSelect: e.target.value })}>
                                                    <optgroup label="Wähle den Kanal">
                                                        <option selected value="1">E-Mail</option>
                                                        <option value="2">E-Mail & Post</option>
                                                    </optgroup>
                                                </select>
                                            </div>
                                        </div>
                                    </div> : (registerPage == 3) ?
                                        // PAGE 3
                                        <div className='register_squircle_cont'>
                                            <div className='register_squircle_first_cont'>
                                                <h3>Wir brauchen noch ein paar Infos</h3>

                                                <form>
                                                    <div className="field tip-parent">
                                                        <b>Dein Geburtsdatum</b>
                                                        <input type="date" className="in_birthdate" name="birthdate" placeholder="Geburtsdatum" autoFocus value={formData.formBirthdate} autoComplete='on' onInput={(e) => setFormData({ ...formData, formBirthdate: e.target.value })}></input>
                                                    </div>
                                                    <div className="field tip-parent">
                                                        <b>Zusatzqualifikationen</b>
                                                        <input type="text" className="in_qualifications" name="qualifications" placeholder="Qualifikationen (optional)" value={formData.formQualifications} autoComplete='off' onInput={(e) => setFormData({ ...formData, formQualifications: e.target.value })}></input>
                                                    </div>
                                                    <div className="field tip-parent">
                                                        <label className="chb_container">
                                                            <input type="checkbox" className="checkbox" name="agb_accepted" value="1" checked={formData.formChbAGB} onChange={(e) => setFormData({ ...formData, formChbAGB: e.target.checked })}></input>
                                                            <span className="checkmark"></span>
                                                            <div className='noselect'>Ich stimme den <a href="https://www.helferzeit.de/rechtliches" target="_blank">AGB und Datenschutzbestimmungen</a> zu</div>
                                                        </label>
                                                        <label className="chb_container">
                                                            <input type="checkbox" className="checkbox" name="fotos_accepted" value="1" checked={formData.formChbFotos} onChange={(e) => setFormData({ ...formData, formChbFotos: e.target.checked })}></input>
                                                            <span className="checkmark"></span>
                                                            <div className='noselect'>Ich stimme dem Erstellen und Veröffentlichen von Fotoaufnahmen im Rahmen aller angemeldeten Events zu (Optional)</div>
                                                        </label>
                                                        <label className="chb_container">
                                                            <input type="checkbox" className="checkbox" name="newsletter_accepted" id="newsletter_allowed" value="1" checked={formData.formChbNewsletter} onChange={(e) => setFormData({ ...formData, formChbNewsletter: e.target.checked })}></input>
                                                            <span className="checkmark"></span>
                                                            <div id="newsletter_accepted_text" className='noselect'>Ich möchte Newsletter und Updates erhalten.<br />(Optional; Benachrichtigungen erhältst du immer)</div>
                                                        </label>
                                                    </div>
                                                    <br />
                                                    {(formError) ? <b className='form_error_message'>Bitte fülle alle Pflichtfelder korrekt aus.</b> : <div></div>}
                                                    <p className="responseInfo" id="responseInfo_loading">
                                                        Lädt... Bitte warten...
                                                    </p>
                                                    <p className="responseInfo" id="responseInfo_wronginput">
                                                        Bitte überprüfe deine Eingaben!<br />
                                                        Fehler: {resError}
                                                    </p>
                                                    <p className="responseInfo" id="responseInfo_servererror">
                                                        Es gab einen Fehler bei der Verarbeitung.<br />
                                                        Fehler: {resError}
                                                    </p>
                                                    <br /><br />
                                                    <CTAButton variant="primary" id="back_btn" hideArrow={true} title={"Zurück"} onclick={() => setRegisterPage(2)}></CTAButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                                    <CTAButton variant="primary" className="register_save_btn" id="save_btn" hideArrow={false} title={"Speichern"} onclick={() => nextRegisterPage(3)}></CTAButton>
                                                </form>
                                            </div>
                                            <div className='register_squircle_scnd_cont'>
                                                <FontAwesomeIcon className='register_squircle_icon' icon={faPersonChalkboard} />
                                                <p className='register_squircle_explanation'>
                                                    Beschreibe hier nur Qualifikationen, die für uns relevant sein könnten.
                                                    Beispiele hierfür sind:<br />
                                                    <i>B-Führerschein, NotSan, Betrieblicher Ersthelfer</i><br /><br />
                                                    Angaben bitte in Stichpunkten und durch Komma getrennt
                                                </p>
                                            </div>
                                        </div> :
                                        < div className='register_squircle_cont'>
                                            <div className='register_squircle_first_cont'>
                                                <h3>{(formData.formVorname == "") ? 'Bitte bestätige deine E-Mailadresse!' : 'Hey ' + formData.formVorname + ', bitte bestätige deine E-Mailadresse!'}</h3>

                                                <p>
                                                    Um die Registrierung abzuschließen musst du deine E-Mailadresse bestätigen. Hierfür erhältst du in den nächsten Minuten per Mail einen Bestätigungslink.<br />
                                                    Falls du keine Mail erhalten hast, <b>prüfe bitte den Spam-Ordner</b> deines E-Mailpostfachs oder kontaktiere uns <a href="https://www.helferzeit.de/support">hierüber</a>.
                                                </p>
                                                <br />

                                            </div>

                                            <br />
                                        </div>
                            }

                            <br />
                        </div>
                    </motion.div>
                </section>

                <section className='container section' style={{ paddingTop: '8px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <div className='card info-card'>
                            <div className='eventinfo_box'>
                                <h2>{eventData.eventInfo.box3Header}</h2>
                                <div className="kv-list">
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarPlus} /><b>Anmeldezeitraum</b> {formatDateWithTime(new Date(eventData.eventDates.applicationStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.applicationEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarDays} /><b>Veranstaltung</b> {formatDateWithTime(new Date(eventData.eventDates.dateStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.dateEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faChampagneGlasses} /><b>Inhalte</b> {eventData.eventInfo.box3Contents}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faUsers} /><b>Benötigte Helfer</b> {eventData.eventInfo.box3LookingFor}</div>
                                </div>
                                <p>{eventData.eventInfo.box3Text}</p>
                                <div className="contact-list">
                                    {(eventData.eventContactMail != "") ? <a href={"mailto:" + eventData.eventContactMail}><FontAwesomeIcon icon={faEnvelope} /> {eventData.eventContactMail}</a> : null}
                                    {(eventData.eventContactTel != "") ? <a href={"tel:" + eventData.eventContactTel}><FontAwesomeIcon icon={faPhone} /> {eventData.eventContactTel}</a> : null}
                                    <a href={eventData.eventURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faGlobe} /> Webseite des Veranstalters</a>
                                    <a href={eventData.eventImprintURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faScaleBalanced} /> Impressum des Veranstalters</a>
                                    <a><FontAwesomeIcon icon={faBuilding} /> Veranstalter: {eventData.eventOrganizator}</a>
                                    {(eventData.eventOrgId) ? <a href={'/events/public/' + eventData.eventOrgId} className="eventinfo_link_eventlist" onClick={(e) => { e.preventDefault(); lP('/events/public/' + eventData.eventOrgId); }}><FontAwesomeIcon icon={faList} /> Weitere öffentliche Events dieser Organisation</a> : null}
                                </div>
                                <CTAButton variant="secondary" size="sm" hideArrow={true} title={eventData.eventInfo.box3CtaText} onclick={() => oP(eventData.eventContactURL)}></CTAButton>
                                <br /><br /><br />
                            </div>
                        </div>
                    </motion.div>

                </section>
            </main>

            < MainFooter useEventStyle={true} />
        </div >
    )
}
